import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";

const CookieNotice = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-16 px-4 mt-10">
        <div className="max-w-4xl mx-auto">
          <motion.h1
            className="text-3xl sm:text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-700 to-indigo-500 mb-4"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Cookie Notice
          </motion.h1>

          <p className="text-sm text-gray-500 text-center mb-8">How we use cookies and similar technologies</p>

          <div className="bg-white rounded-2xl shadow-md p-6 space-y-6">
            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">What are cookies?</h2>
              <p className="text-gray-600 leading-relaxed">
                Cookies are small text files stored on your device to help our site remember preferences, analyze traffic, and provide improved functionality.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Types of cookies we use</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li><strong>Essential:</strong> Required for site functionality (cart, security).</li>
                <li><strong>Performance:</strong> Help us understand traffic and usage.</li>
                <li><strong>Functional:</strong> Remember preferences (language, region).</li>
                <li><strong>Advertising:</strong> Third-party cookies used for personalized ads.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Managing cookies</h3>
              <p className="text-gray-600 leading-relaxed">
                You can set your browser to block or alert you about cookies. Blocking some cookies may impact site functionality. For advertising cookies, you may manage preferences via your device/browser settings or opt-out tools provided by advertisers.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Contact</h3>
              <p className="text-gray-600 leading-relaxed">
                Questions about our cookie practices? Contact <strong>privacy@hlc.com</strong>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieNotice;
